module.exports = __webpack_public_path__ + "./bd6fc6a8b80df8fdbe652a7d431e7ce4-icon-service-default-small@2x.png";


//////////////////
// WEBPACK FOOTER
// ./plugins/services/src/img/icon-service-default-small@2x.png
// module id = 1082
// module chunks = 0